import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-polygon",
  "use": "icon-polygon-usage",
  "viewBox": "0 0 1075 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1075 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-polygon\"><path d=\"M831.63428566 969.75238133H228.93714266L42.66666666 398.72609533 530.28571466 45.71428533l487.619047 352.889905-186.270476 571.026286zM530.28571466 112.20114333L110.66514266 418.10895233l163.888762 500.370286H785.79809566l162.547809-500.321524L530.28571466 112.20114333z\" p-id=\"2847\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol